import React, { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Dialog } from "@mui/material";
import {
  apply,
  couponApplied,
  couponRewardMessage,
  enjoyBenefits,
  noCoupons,
  remove,
  viewCoupons,
} from "./messages";
import {
  checkCircleCurved,
  couponCodeIcon,
  couponCodeIconGrey,
} from "./images";
import Text from "./text/Text";
import { CustomLink } from "./link/Link";
import CouponCodesList from "./CouponCodesList";
import CodeAppliedDialog from "./CodeAppliedDialog";
import CommonSkeleton from "./CommonSkeleton";

const ApplyCouponCode = ({
  couponCodes,
  appliedCoupon,
  setAppliedCoupon,
  isFromBrowser,
  validateCoupon,
  isLoading,
}) => {
  const [isCouponListOpen, setIsCouponListOpen] = useState(false);
  const [suggestedCoupon, setSuggestedCoupon] = useState(null);
  const [codeAppliedPopupOpen, setCodeAppliedPopupOpen] = useState(false);
  const [hasShownPopup, setHasShownPopup] = useState(false);

  const isCouponCodesAvailable = couponCodes.length !== 0;

  const openCodeAppliedPopup = () => {
    setCodeAppliedPopupOpen(true);
    setTimeout(() => {
      setCodeAppliedPopupOpen(false);
    }, 3000);
  };

  const handleApplyClick = async () => {
    if (appliedCoupon) {
      setAppliedCoupon(null);
    } else {
      const isValid = await validateCoupon(suggestedCoupon);
      if (isValid) {
        setAppliedCoupon(suggestedCoupon);
        if (!hasShownPopup) {
          openCodeAppliedPopup();
          setHasShownPopup(true);
        }
      }
    }
  };

  useEffect(() => {
    const activeCoupon = couponCodes?.find(
      (couponCode) => couponCode.is_eligible
    );
    setSuggestedCoupon(activeCoupon);
  }, [couponCodes]);

  const listProps = {
    couponCodes,
    appliedCoupon,
    setAppliedCoupon,
    isCouponListOpen,
    setIsCouponListOpen,
    setCodeAppliedPopupOpen,
    isFromBrowser,
    validateCoupon,
    openCodeAppliedPopup,
    hasShownPopup,
    setHasShownPopup,
  };

  return (
    <>
      <CouponCodesList {...listProps} />
      <Box className="coupon-code" marginTop="10px">
        {isLoading && !appliedCoupon ? (
          <Box display="flex" alignItems="center" gap={1}>
            <CommonSkeleton variant="circular" width={20} height={20} />
            <CommonSkeleton width={180} height={20} />
          </Box>
        ) : suggestedCoupon ? (
          <Box
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="flex-start" gap={1}>
              <img
                src={appliedCoupon ? checkCircleCurved : couponCodeIconGrey}
                height={20}
                width={20}
              />
              <Box display="flex" flexDirection="column" gap={0.5}>
                <Text className="default-text" size={14} font="medium">
                  {appliedCoupon
                    ? appliedCoupon?.help_text
                    : suggestedCoupon?.help_text}
                </Text>
                <CustomLink
                  alignIcon="end"
                  withIcon={<KeyboardArrowRightIcon />}
                  color="primary"
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    setIsCouponListOpen(true);
                  }}
                >
                  {viewCoupons.toUpperCase()}{" "}
                </CustomLink>
              </Box>
            </Box>
            <CustomLink
              color={appliedCoupon ? "error" : "primary"}
              style={{
                fontSize: "12px",
                fontWeight: "600",
                margin: "4px",
              }}
              onClick={handleApplyClick}
            >
              {appliedCoupon ? remove.toUpperCase() : apply.toUpperCase()}
            </CustomLink>
          </Box>
        ) : (
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              if (isCouponCodesAvailable) {
                setIsCouponListOpen(true);
              }
            }}
          >
            <Box
              gap={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <img src={couponCodeIconGrey} height={20} width={20} />
              <Text font="semibold">
                {isCouponCodesAvailable ? viewCoupons : noCoupons}
              </Text>
            </Box>
            {isCouponCodesAvailable && <KeyboardArrowRightIcon />}
          </Box>
        )}
      </Box>

      {codeAppliedPopupOpen && (
        <CodeAppliedDialog
          codeAppliedPopupOpen={codeAppliedPopupOpen}
          setCodeAppliedPopupOpen={setCodeAppliedPopupOpen}
        />
      )}
    </>
  );
};

export default ApplyCouponCode;
